import React from "react";

const DisconnectedView = () => <div style={{ position: "absolute" }}></div>;

export default DisconnectedView;
